/**
 * @typedef {import('@goodt-wcore/elem').StoreOperationType} StoreOperationType
 */

import { resolveAddedAndDeleted } from '../../mixins/utils';

export default {
    created() {
        const { descriptor } = this;
        const varsMeta = descriptor.dataset?.vars;

        if (varsMeta != null) {
            const {
                metric: { operation: metricOperations = [] } = {},
                dimension: { operation: dimensionOperations = [] }
            } = varsMeta;
            if (metricOperations.length > 0) {
                // from 'PanelDatasetWatchStoreMixin.queryParams'
                this.$watch('queryParams.metrics', this.$createHandler(metricOperations));
            }
            if (dimensionOperations.length > 0) {
                // from 'PanelDatasetWatchStoreMixin.queryParams'
                this.$watch('queryParams.dimensions', this.$createHandler(dimensionOperations));
            }
        }
    },
    methods: {
        $createHandler(operations) {
            return (newParams, oldParams = []) => {
                if (newParams.length === 0 && oldParams.length === 0) {
                    return;
                }
                const [addedParams] = resolveAddedAndDeleted(newParams, oldParams);
                if (addedParams.length === 0) {
                    return;
                }
                this.$storeAutoMapVarAliases(addedParams, operations);
            };
        },
        /**
         * Update this.props.varAliases mapping in elemInstance
         *
         * @param {string[]} params
         * @param {StoreOperationType} operations
         */
        $storeAutoMapVarAliases(params, operations) {
            params.forEach((paramName) => {
                this.$storeMeta.setVar({ varAlias: paramName, operation: operations });
            });
            this.$storeMeta.saveVars();
        }
    }
};
